export default class DisplayCondition {

    public inputId: string | null = null;
    public inputValue: string | null = null;
    public inputValueId: string | null = null;
}